import styled from '@emotion/styled';
import { css } from '@emotion/react';

import breakpoints from 'app/styles/constants/breakpoints';

const { widthSmall, widthMediumExtended } = breakpoints;

const S = {};

S.Buttons = styled.div`
  label: Buttons;

  --bottom-spacing: ${({ isEligibleToSkipFreeTrial }) =>
    isEligibleToSkipFreeTrial ? '1.5rem' : '2rem'};

  margin-top: ${({ isFree }) => (isFree ? '2rem' : '1.5rem')};
  margin-bottom: var(--bottom-spacing);

  @media (${widthSmall}) {
    margin-bottom: 0rem;
  }

  @media (${widthMediumExtended}) {
    ${({ isFree }) =>
      isFree
        ? css`
            margin-top: 2.625rem;
            margin-bottom: 3.5rem;
          `
        : css`
            margin-bottom: var(--bottom-spacing);
          `};
  }
`;

export default S;
